module.exports = __webpack_public_path__ + "static/media/Santísimo_Sacramento_small.e4a8ff0b.jpg";